/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ADMINISTRATION } from 'dxpAdministration-mf/Constants';
import { CONVERSATIONS } from 'dxpArtificialIntelligence-mf/Constants';
import { COMPONENT_SERVICE } from 'dxpComponentService-mf/Constants';
import { CONFIGURATION } from 'dxpConfiguration-mf/Constants';
import { CUSTOMER_DATA_PLATFORM } from 'dxpCustomerDataPlatform-mf/Constants';
import { DIGITAL_ASSET_MANAGEMENT } from 'dxpDigitalAssetManagement-mf/Constants';
import {
  ADVANCED_FORMS,
  CONTENT_MANAGEMENT,
  DATA_SERVICES,
  INTEGRATIONS,
  SEARCH,
} from 'dxpInstanceManagement-mf/Constants';
import { MONITORING } from 'dxpMonitoring-mf/Constants';
import { OPTIMIZATION } from 'dxpOptimization-mf/Constants';
import { DxpCapability } from './DxpCapabilities/defs/DxpCapability.defs';

/**
 * All active DXP capabilities.
 */
export const DXP_CAPABILITIES: Array<DxpCapability> = [
  ADMINISTRATION,
  ADVANCED_FORMS,
  COMPONENT_SERVICE,
  CONFIGURATION,
  CONTENT_MANAGEMENT,
  CONVERSATIONS,
  CUSTOMER_DATA_PLATFORM,
  DATA_SERVICES,
  DIGITAL_ASSET_MANAGEMENT,
  INTEGRATIONS,
  MONITORING,
  OPTIMIZATION,
  SEARCH,
];
